import { render, staticRenderFns } from "./ProcessModifyVinculation.vue?vue&type=template&id=4aed8018"
import script from "./ProcessModifyVinculation.vue?vue&type=script&lang=js"
export * from "./ProcessModifyVinculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports